module.exports = __webpack_public_path__ + "static/img/img57.5e10eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img57.png
// module id = v87c
// module chunks = 1